import { render, staticRenderFns } from "./TemperatureViolationTrends.vue?vue&type=template&id=561a6650&scoped=true&"
import script from "./TemperatureViolationTrends.vue?vue&type=script&lang=js&"
export * from "./TemperatureViolationTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a6650",
  null
  
)

export default component.exports